const helper = {
    cloneObject(obj) {
        const json = JSON.stringify(obj);
        const clone = JSON.parse(json);
        return clone;
    },
};

export default helper;
